import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AllClientsComponent } from './all-clients/all-clients.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { ClientsLogComponent } from './clients-log/clients-log.component';
import { ClientsPaymentComponent } from './clients-payment/clients-payment.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxPrintModule } from 'ngx-print';



@NgModule({
  declarations: [
    AllClientsComponent,
    ClientsLogComponent,
    ClientsPaymentComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatPaginatorModule,
    MatDialogModule,
    MatTooltipModule,
    NgxPrintModule
  ]
})
export class ClientsModule { }
